import React, { useState, useEffect } from "react";
import { KeyIcon, ClipboardDocumentIcon } from "@heroicons/react/24/outline";
import { useAuth } from "../../contexts/AuthContext";
import { usersService } from "../../services/api";
import toast from "react-hot-toast";

function ApiPage() {
  const { user } = useAuth();
  const [apiKey, setApiKey] = useState("");

  useEffect(() => {
    //
  }, [user]);

  const copyApiKey = () => {
    navigator.clipboard.writeText(apiKey);
    toast.success("API anahtarı kopyalandı!");
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">API Erişimi</h1>
        <p className="text-gray-600">
          Link kısaltma API'mızı kullanarak kendi uygulamalarınızı geliştirin
        </p>
      </div>

      <div className="card">
        <div className="card-header">
          <h2 className="text-lg font-semibold text-gray-900">
            API Anahtarınız
          </h2>
        </div>
        <div className="card-body">
          <div className="flex items-center space-x-4">
            <input
              type="text"
              readOnly
              className="form-input flex-1 bg-gray-50"
            />
            <button onClick={copyApiKey} className="btn btn-primary">
              <ClipboardDocumentIcon className="w-4 h-4 mr-2" />
              Kopyala
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ApiPage;
